import React, { useEffect, useState } from 'react'
import { useBnsBaoZhuangListQuery,} from '../../store/ReactWebSiteApi';
import { Select,Form, Space} from 'antd';
import { useBnsGoodsListQuery } from '../../store/BnsKeJiApi';

function PackageForm(props) {
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsGoodsListQuery({bg_e_id:'218'},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bg_id:key,bg_name} = item;
                    return item = {value:key,label:bg_name}
                })                
                setList(newArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const [product,setProduct] = useState()
    const [listPackage,setListPackage] = useState()
    const {data:dataPackage, isSuccess:isSuccessPackage} = useBnsBaoZhuangListQuery({bbz_e_id:localStorage.getItem('e_id'),bbz_bg_id:product},{refetchOnMountOrArgChange:1,skip:!product});    
    useEffect(() => {
        if (isSuccessPackage) {
            if(dataPackage.Status==='success'){                
                const newArr = dataPackage.Result.map(item => {
                    const {bbz_id:key,bbz_name} = item;
                    return item = {value:key,label:bbz_name}
                })                
                setListPackage(newArr)
            }else{
                setListPackage('')
            }
            
        }
    }, [dataPackage, isSuccessPackage])
    return (
        <Form.Item
            label='推广方案'
            style={{marginBottom:"0"}}
            wrapperCol={{span:'20'}}
            required
        >
            <Space>
                <Form.Item                
                    name={props.name}
                    wrapperCol={props.wrapperCol}
                    required={props.required}
                    style={{width:"200px"}}
                >
                    <Select
                        options={list}
                        onChange={(e,f) => {
                            setProduct(e)
                            props.onChange(e,f)                            
                        }}
                    />
                </Form.Item>
                <Form.Item                
                    name={props.namePackage}
                    style={{width:"200px"}}
                >
                    <Select
                        options={listPackage}
                        onChange={(e,f) => {
                            props.onChangePackage(e,f)
                        }}
                    />
                </Form.Item>
            </Space>
        </Form.Item>
    )
}

export default PackageForm